import { Component, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';

interface IActivateAccountModalContext {
  account: any;
}
@Component({
  selector: 'app-activate-account-modal',
  templateUrl: './activate-account-modal.component.html',
  styleUrls: ['./activate-account-modal.component.scss'],
})
export class ActivateAccountModalComponent implements OnInit {
  pending = false;
  success: any;
  error: any;
  banks;
  selectedBank;
  terms;
  accountName;
  accountNumber;
  ibanNumber: string;
  sortCode: string;
  intermediaryBankSwiftCode;
  bankAddress;
  agreementAccepted = false;
  viewTerms = false;

  constructor(
    public modal: SuiModal<IActivateAccountModalContext, void, void>,
    private walletService: EwalletService
  ) {}

  ngOnInit() {
    this.getAllBanks();
    this.getTerms();
  }

  getAllBanks() {
    this.error = null;
    this.walletService
      .getBanks({
        currency: this.modal.context.account.currencyShortName.toLowerCase(),
      })
      .subscribe(
        (res: any) => {
          this.banks = res;
        },
        (error) => {
          this.error = error.error;
        }
      );
  }

  getTerms() {
    this.error = null;
    this.walletService.getTermsAndCondition().subscribe(
      (res: any) => {
        this.terms = res;
        this.pending = false;
      },
      (error) => {
        this.error = error.error;
      }
    );
  }

  agreeToTerms() {
    this.agreementAccepted = true;
    this.viewTerms = false;
  }

  disagreeToTerms() {
    this.agreementAccepted = false;
    this.error =
      'You must agree to the terms and conditions to activate your account';
    this.viewTerms = false;
  }

  activateAccount() {
    this.pending = true;
    this.error = null;
    const account = this.modal.context.account;
    let body;
    if (this.modal.context.account.currencyShortName.includes('DOLLAR')) {
      body = {
        bankName: this.selectedBank,
        bankAccountName: this.accountName,
        bankAccountNumber: this.accountNumber,
        routingNumber: this.ibanNumber ? this.ibanNumber : '',
        sortCode: this.sortCode ? this.sortCode : '',
        intermediarySortCode: this.intermediaryBankSwiftCode
          ? this.intermediaryBankSwiftCode
          : '',
        bankPhysicalAddress: this.bankAddress ? this.bankAddress : '',
      };
    } else {
      body = {
        bankId: this.selectedBank.optionId,
        bankName: this.selectedBank.optionName,
        bankAccountName: this.accountName,
        bankAccountNumber: this.accountNumber,
      };
    }
    this.walletService.activateCurrency({ body }).subscribe(
      (res: any) => {
        this.success = 'Currency Successfully activated';
        this.pending = false;
        this.modal.approve(null);
      },
      (error) => {
        this.pending = false;
        this.error = error.error;
      }
    );
  }

  capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  openTAndC(e: any) {
    e.stopPropagation();
    this.viewTerms = true;
  }
}

export class ActivateAccountModal extends ComponentModalConfig<
  IActivateAccountModalContext,
  void,
  void
> {
  constructor(account: any, size: ModalSize = ModalSize.Mini) {
    super(ActivateAccountModalComponent, {
      account,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
